import helpers from "../helpers";

const init = () => {
	let slider = $('.chapter__slider');

	if (slider.length) {
		new Swiper('.chapter__slider', {
			slidesPerView: "auto",
			spaceBetween: 0,
		});

		// if(helpers.isMobile()) {
		// 	helpers.$document.on('touchstart', function() {
		// 		setTimeout(() =>{
		// 			slider.css('pointer-events', 'none')
		// 		}, 500)
		// 	});
		//
		// 	helpers.$document.on('touchend', function() {
		// 		slider.css('pointer-events', 'auto');
		// 	});
		// }
	}
}

export default {
	init,
}
